import axios from 'axios'

const baseURL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL,
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
})

let refreshPromise = null

api.interceptors.request.use((config) => {
  // Defer the auth store import — circular import safe. "Remember me" may have
  // persisted the bundle to localStorage; otherwise it's session-only.
  try {
    const stored = (typeof localStorage !== 'undefined' && localStorage.getItem('psnap:auth'))
      || (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('psnap:auth'))
    if (stored) {
      const parsed = JSON.parse(stored)
      if (parsed?.idToken) config.headers.Authorization = `Bearer ${parsed.idToken}`
    }
  } catch { /* ignore */ }
  return config
})

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config || {}
    const status = error.response?.status

    if (status === 401 && !original.__retried) {
      original.__retried = true
      try {
        if (!refreshPromise) {
          const { useAuthStore } = await import('@/stores/authStore')
          const auth = useAuthStore()
          refreshPromise = auth.refreshSession().finally(() => { refreshPromise = null })
        }
        await refreshPromise
        return api(original)
      } catch {
        // Refresh failed — let the caller surface the error; router guard sends to /login on next nav.
        if (typeof window !== 'undefined') {
          const next = window.location.pathname + window.location.search
          window.location.assign(`/login?next=${encodeURIComponent(next)}`)
        }
      }
    }

    return Promise.reject(error)
  },
)

export default api
